import styled from "styled-components";

export const TitleWrapper = styled.header`
    h1{
        font: 3.25rem/1 'Titan One',arial,sans-serif;
        color: ${props => props.textColor };
    }

    @media screen and (min-width: 320px) and (max-width: 480px){
        h1{
            font-size: 2rem;
        }
    }
`;